export class AccountUpdate
{
    storeid: string;
    password: string;
    accounttype: string;
    role: string;      
    commissionmodel: string;
    notificationurl: string;
    rate: string; 
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/accountupdatemodel.ts